"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const TwitterIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M16 2.657a6.203 6.203 0 01-1.885.557 3.511 3.511 0 001.443-1.956c-.634.405-1.337.7-2.085.858C12.875 1.43 12.022 1 11.078 1 9.265 1 7.795 2.582 7.795 4.534c0 .277.029.547.085.806-2.728-.148-5.147-1.555-6.766-3.693a3.726 3.726 0 00-.445 1.777c0 1.226.58 2.308 1.46 2.942a3.094 3.094 0 01-1.486-.443v.045c0 1.712 1.131 3.14 2.633 3.465a3.068 3.068 0 01-1.483.061c.418 1.404 1.63 2.426 3.067 2.455-1.124.947-2.539 1.512-4.077 1.512-.265 0-.526-.016-.783-.049A8.818 8.818 0 005.032 15c6.038 0 9.34-5.385 9.34-10.056 0-.153-.004-.306-.01-.457A6.979 6.979 0 0016 2.657z",
    clipRule: "evenodd"
  })))
});
TwitterIcon.displayName = 'TwitterIcon';
var _default = exports.default = TwitterIcon;